import {request, setAuthInHeader} from "@/api/request";

const state = {
    UserInfo: {},
    UserImg: {},
    SiteInfo: {},
    SiteLogo: {},
    data: {},
    filterSet: {},
};

const getters = {
    getUserImg: state => state.UserImg,
    getSiteInfo: state => state.SiteInfo,
    getSiteLogo: state => state.SiteLogo,
    getFilterSet: state => state.filterSet,
};

const mutations = {
    updateUserImg(state, obj) {
        state.UserImg = obj.value;
    },
    updateSiteInfo(state, obj) {
        state.SiteInfo = obj.value;
    },
    updateSiteLogo(state, obj) {
        state.SiteLogo = obj.value;
    },
    updateData(state, obj) {
        if (obj.key) {
            state.data[obj.key] = obj.data;
        } else {
            state.data = obj.data;
        }
    },
    updateFilterSet(state, obj) {
        state.filterSet = obj.data;
    },
};

const actions = {
    async initUserImg({commit, rootState}, {info}) {
        await commit('updateUserImg', {'value': info})
    },
    async initSiteInfo({commit, rootState}, {info}) {
        await commit('updateSiteInfo', {'value': info})
    },
    async initSiteLogo({commit, rootState}, {info}) {
        await commit('updateSiteLogo', {'value': info})
    },
    setData({commit, rootState}, {data, key}) {
        commit('updateData', {data: data, key: key});
    },
    setFilterSet({commit, rootState}, {data}) {
        commit('updateFilterSet', {data: data});
    },
    setUserImg({commit, rootState}, {mb_no}) {
        let params = {a_container_type: 'profile', a_container_id: mb_no};
        request.get('file', params)
            .then((res) => {
                let result = res.data.Data.Result;
                if (result.Info.status && result.List.length > 0) {
                    let file = result.List[0];
                    file.url = file.thumb_url;
                    file.name = file.org_name;
                    commit('updateUserImg', {'value': file});
                }

            }, () => {
                console.log('error');
            })
    },
    setSiteLogo({commit, rootState}) {
        let params = {a_container_type: 'siteLogo'};
        request.get('file', params).then((res) => {
            let result = res.data.Data.Result;
            if (result.Info.status && result.List.length > 0) {
                let file = result.List[0];
                file.url = file.thumb_url;
                file.name = file.org_name;
                commit('updateSiteLogo', {'value': file});
            }
        }, () => {
            console.log('error');
        })
    },
    setSiteInfo({commit, rootState}) {
        request.get('config/info').then((res) => {
            let result = res.data.Data.Result;
            if (result.Info.status && result.List.length > 0) {
                let list = result.List[0];
                commit('updateSiteInfo', {'value': list});
            }
        }, () => {
            console.log('error');
        })
    },
    setImageProfile({commit, rootState}, {mb_no}) {

    }
};

export default {namespaced: true, state, getters, mutations, actions}
